export enum BetType {
	Deposit = 'deposit',
	Bonus = 'bonus',
	Freebet = 'freebet',
}
